import React, { createContext, useState, ReactNode } from 'react';
import { EventType } from '../core/apiTypes';

type EventContextType = {
    currentEvent: EventType | null;
    setEvent: (event: EventType | null) => void;
};

const EventContext = createContext<EventContextType | undefined>(undefined);

export const EventProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [currentEvent, setCurrentEvent] = useState<EventType | null>(null);

    const setEvent = (event: EventType | null) => {
        setCurrentEvent(event);
    };

    return <EventContext.Provider value={{ currentEvent, setEvent }}>{children}</EventContext.Provider>;
};

export default EventContext;
